<div class="flex-fill d-flex flex-column">
    <div class="btn-toolbar mx-3 mb-0 mt-3">
        <div class="col-sm-10">
            <button type="button" (click)="save()" class="btn btn-primary mr-2" *ngIf="hasChanges()">Save</button>
            <button type="button" (click)="cancel()" class="btn btn-success mr-2" *ngIf="hasChanges()">Cancel</button>
            <button type="button" (click)="close()" class="btn btn-primary mr-2" *ngIf="!hasChanges()">Close</button>
        </div>
        <div class="col-sm-2 d-flex justify-content-end">
            <!-- <button type="button" (click)="delete()" class="btn btn-danger">Delete</button> -->
        </div>
    </div>

    <div class="grid-fill m-3">
        <dx-form [formData]="employee" *ngIf="employee" [colCount]="2" validationGroup="mainValidationGroup">
            <dxi-item itemType="group">
                <dxi-item itemType="group" caption="Employee Information">
                    <dxi-item class="mt-2" itemType="group" [colCount]="2">
                        <dxi-item dataField="firstName">
                            <dxi-validation-rule type="required" message="First Name Required"> </dxi-validation-rule>
                        </dxi-item>
                        <dxi-item dataField="middleName"></dxi-item>
                    </dxi-item>
                    <dxi-item dataField="lastName">
                        <dxi-validation-rule type="required" message="Last Name Required"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="email"></dxi-item>
                    <dxi-item dataField="cellPhone"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Notes">
                    <dxi-item dataField="note" [label]="{ text: 'Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" caption="Address">
                <dxi-item dataField="address1"></dxi-item>
                <dxi-item dataField="address2"></dxi-item>

                <dxi-item itemType="group" [colCount]="4">
                    <dxi-item dataField="city" [label]="{ text: 'City' }" [colSpan]="2"></dxi-item>
                    <dxi-item dataField="state" [label]="{ text: 'State' }"></dxi-item>
                    <dxi-item dataField="zip" [label]="{ text: 'Zip' }"></dxi-item>
                </dxi-item>
                <dxi-item itemType="group" caption="Employment Information">
                    <dxi-item dataField="startDate" editorType="dxDateBox"></dxi-item>
                    <dxi-item dataField="endDate" editorType="dxDateBox"></dxi-item>
                </dxi-item>
            </dxi-item>
        </dx-form>
    </div>
</div>
